import PosterReel from './PosterReel';
import PosterReelSkeleton from './PosterReel.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <PosterReelSkeleton {...props} /> : <PosterReel {...props} />;
}
